module.exports = __webpack_public_path__ + "img/drawing_shumiao.a2d84fad.png";